<footer class="base-footer">
  <span class="copyright">&#169;</span>
  <span>copyright {{ ano }} - BRASILCAP. Todos os direitos reservados</span>
</footer>
